/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-show-on-change]';
const ATTR_ELEMENT_SELECTOR = 'data-show-on-change-element-to-show';
const ATTR_SHOW_IF_NOT_EMPTY = 'data-show-on-change-if-not-empty';
const PLUGIN_NAME = 'showOnChange';
const MODULE_NAME = 'app.core/modules/show-on-change';
const log = debug(MODULE_NAME);

log('registerd');

class ShowOnChange {

  constructor(element, options) {
      log('new instance', element, options);

      this.element = element;
      this.options = options;
      this.$element = $(element);
      this.elementToShow = this.$element.attr(ATTR_ELEMENT_SELECTOR);
      this.$elementToShow = $(this.elementToShow);
      this.showIfNotEmpty = this.element.hasAttribute(ATTR_SHOW_IF_NOT_EMPTY);
      this.$element.on('keyup', this.change.bind(this));
      this.$element.on('change', this.change.bind(this));

      log('ready', this.$element);

      this.change();
  }

  change () {
    var isChecked = this.$element.is(':checkbox') || this.$element.is(':radio') ? this.$element.is(':checked') : true;  
    this.value = this.$element.val();
    if (this.$element.length > 1 && isChecked) {
        var selector =  this.$element.attr(ATTR_ELEMENT_SELECTOR);
        this.value = $(selector + ':checked').val();
    }
    if (this.value == null) {
        this.value = '';
    }

    log('change', this.$element, this.value, this.initial);
    if (this.showIfNotEmpty) {
        if (this.value.length > 0) {
            this.$elementToShow.show();
        }
        else {
            this.$elementToShow.hide();
        }
    }   
  }
}

plugin(PLUGIN_NAME, ShowOnChange);

export function exec () {
  $(document).ready(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./client/src/core/components/show-on-change/index.js